<template>
  <div class="page-warp">
    <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="totalRows" :current-page="currentPage" :page-size="changeSize" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" ></el-pagination>
  </div>
</template>

<script>
export default {
  name: 'customPagination',
  components: {},
  props: {
    totalRows: {
      type: Number
    },
    pageNo: {
      type: Number
    },
    pageSizes: {
      default() {
        return [100, 200]
      }
    },
    pageSize: {
      type: Number
    }
  },
  data() {
    return {
      changeSize: 100,
      currentPage: 1
    }
  },
  watch: {
    pageNo: {
      handler(val) {
        this.currentPage = val
      },
      deep: true,
      immediate: true
    },
    pageSize: {
      handler(val) {
        this.changeSize = val
      },
      deep: true,
      immediate: true
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit('changePage', { 'pageNo': val, 'pageSize': this.changeSize })
    },
    handleSizeChange(val) {
      this.changeSize = val
      this.$emit('changeSize', { 'pageNo': this.currentPage, 'pageSize': val })
    }
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
.el-pagination {
  float: right;
  height: 30px;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/userManagementList/customPagination/index.vue